// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyA7eg4ytYRH-SkemXjNnuvJLrU_j-KGens",
  authDomain: "isayyashtothat.firebaseapp.com",
  projectId: "isayyashtothat",
  storageBucket: "isayyashtothat.firebasestorage.app",
  messagingSenderId: "66047244965",
  appId: "1:66047244965:web:1a53503b6502e787736b4c",
  measurementId: "G-14PZ18L7HJ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app);

export { app, analytics, auth, db };